// extracted by mini-css-extract-plugin
module.exports = {"link":"NounderNounContent_link__3MuKL","bidRow":"NounderNounContent_bidRow__2CVAB","currentBidCol":"NounderNounContent_currentBidCol__3VQRX"};